import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';
import {connect} from "react-redux";

export const MODULE_NAME = 'VATNUMBER_MODULE';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);
function namespaced(name) {
    return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const CERTIFICATE_INVALID = namespaced('CERTIFICATE_INVALID');
const CERTIFICATE_VALID = namespaced('CERTIFICATE_VALID');
const DELETE_SII_CERTIFICATE = namespaced('DELETE_SII_CERTIFICATE');
const DELETE_SII_CERTIFICATE_SUCCESS = namespaced('DELETE_SII_CERTIFICATE_SUCCESS');
const DELETE_SII_CERTIFICATE_FAILED = namespaced('DELETE_SII_CERTIFICATE_FAILED');
const GET_SII_CERTIFICATE_FAILED = namespaced('GET_SII_CERTIFICATE_FAILED');
const GET_SII_CERTIFICATE_SUCCESS = namespaced('GET_SII_CERTIFICATE_SUCCESS');

// For now we are overloading the use of UPDATE to include delete too.

export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL,
    CERTIFICATE_INVALID,
    CERTIFICATE_VALID,
    DELETE_SII_CERTIFICATE,
    DELETE_SII_CERTIFICATE_SUCCESS,
    DELETE_SII_CERTIFICATE_FAILED,
    GET_SII_CERTIFICATE_SUCCESS,
    GET_SII_CERTIFICATE_FAILED
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
    log.debug('actionHandler: ', action, state );
    const getNewState = (action, state) => {
        switch (action.type) {
            case LOAD:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_OK:
                return Object.assign({}, state, {data: action.response, loading: false, error: null});
            case LOAD_FAIL:
                return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
            case CERTIFICATE_VALID:
                return Object.assign({}, state, {thumbprint: action.response.thumbprint, expiryDate: action.response.expiryDate, loading: false, error: null});
            case CERTIFICATE_INVALID:
                return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
            case DELETE_SII_CERTIFICATE:
                return Object.assign({}, state, {isSiiCertificateDeleted: false });
            case DELETE_SII_CERTIFICATE_SUCCESS:
                return Object.assign({}, state, {isSiiCertificateDeleted: true , loading: false, error: null});
            case DELETE_SII_CERTIFICATE_FAILED:
                return Object.assign({}, state, {isSiiCertificateDeleted: false, loading: false, error: action.error});
            case GET_SII_CERTIFICATE_SUCCESS:
                    return Object.assign({}, state, {isSiiCertificatePresent: true , loading: false, error: null});
            case GET_SII_CERTIFICATE_FAILED:
                    return Object.assign({}, state, {isSiiCertificatePresent: false, loading: false, error: action.error});
            default:
                return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('actionHandler:  newState', newState );
    return newState;
};

export const API = {
    doValidateVATNumber: (vatnumber,callback) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD});
            CLIENT.doValidateVatNumber(vatnumber)
                .then((response) => {
                    callback(response);
                    dispatch({type: LOAD_OK, response: response});
                })
                .catch((error) => {
                    dispatch({type: LOAD_FAIL, error});
                });
        }
    },
    doValidateSiiCertificate: (certificateFile, password, validHandler, invalidHandler) => {
        return (dispatch, getstate) => {
            CLIENT.doValidateSiiCertificate(certificateFile, password)
                .then((response) => {
                    dispatch({type: CERTIFICATE_VALID, response});
                    validHandler(response);
                })
                .catch((error) => {
                    dispatch({type: CERTIFICATE_INVALID, error});
                    invalidHandler(error);
                });
        };
    },
    doDeleteSiiCertificate: (vatNumberId, validHandler, invalidHandler) => {
        return (dispatch, getstate) => {
            dispatch({type: LOAD});
            CLIENT.doDeleteSiiCertificate(vatNumberId)
                .then((response) => {
                    dispatch({type: DELETE_SII_CERTIFICATE_SUCCESS, response});
                    validHandler(response);
                })
                .catch((error) => {
                    dispatch({type: DELETE_SII_CERTIFICATE_FAILED, error});
                    invalidHandler(error);
                });
        };
    },
    isSiiCertificatePresent: (vatNumberId, validHandler, invalidHandler) => {
        return (dispatch, getstate) => {
            dispatch({type: LOAD});
            CLIENT.isSiiCertificatePresent(vatNumberId)
                .then((response) => {
                    dispatch({type: GET_SII_CERTIFICATE_SUCCESS, response});
                    validHandler(response);
                })
                .catch((error) => {
                    dispatch({type: GET_SII_CERTIFICATE_FAILED, error});
                    invalidHandler(error);
                });
        };
    }
};

export default API;

